import { getTracking } from '@vp/tracking';
import { validateEntryPagesTrackingPayload } from './validate.js';

const trackEntryPagesEvent = (eventName, trackingProperties, logger) => {
  const tracking = getTracking();
  if (tracking) {
    tracking.track(eventName, trackingProperties, {});
  } else {
    const uuid = crypto.randomUUID();
    logger.warn(`Tracking not available for event: ${eventName}. Waiting for trackingReady event.`, { trackingUuid: uuid });
    const options = { once: true };
    window.addEventListener(
      "trackingReady",
      () => {
        const newTracking = getTracking();
        newTracking?.track(eventName, trackingProperties, {});
        logger.info(`Tracking event ${eventName} sent after trackingReady event.`, { trackingUuid: uuid });
      },
      options
    );
  }
};
const validateAndTrackEntryPagesEvent = (eventName, properties, schema, logger) => {
  validateEntryPagesTrackingPayload(eventName, properties, schema, logger);
  trackEntryPagesEvent(eventName, properties, logger);
};

export { trackEntryPagesEvent, validateAndTrackEntryPagesEvent };
//# sourceMappingURL=track.js.map
